module.exports = __webpack_public_path__ + "img/platform.546b3f39.png";